<template>
  <RevBreadcrumbs
    :ariaLabel="i18n(translations.breadcrumbAriaLabel)"
    :breads
    class="px-16 md:px-32"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevBreadcrumbs } from '@ds/components/Breadcrumbs'
import type { Bread } from '@ds/components/Breadcrumbs/Breadcrumbs.vue'

import translations from './BuybackBreadcrumb.translations'

defineProps<{
  breads: Bread[]
}>()

const i18n = useI18n()
</script>
